import React from 'react';
import { Col, Row } from 'react-bootstrap';
import useMJOOptions from 'hooks/Meteorology/Weather/Area/Status/MJO/useMJOOptions';
import CentralizedSpinner from 'components/CentralizedSpinner';
import useIsMobile from 'utils/hooks/useIsMobile';
import DiagramPanel from './DiagramPanel';
import PredictionPanel from './PredictionPanel';

export default function MJO() {
  const isMobile = useIsMobile();
  const { data, isLoading } = useMJOOptions();

  if (isLoading) {
    return <CentralizedSpinner />;
  }

  if (isMobile) {
    return (
      <div className="status-stack-mobile">
        <DiagramPanel models={data?.statusModels || []} />
        <PredictionPanel
          models={data?.predictionModels || []}
          variables={data?.predictionVariables || []}
        />
      </div>
    );
  }

  return (
    <Row className="flex-fill p-5 h-100">
      <Col xl={6}>
        <DiagramPanel models={data?.statusModels || []} />
      </Col>
      <Col xl={6} className="mt-3 mt-xl-0">
        <PredictionPanel
          models={data?.predictionModels || []}
          variables={data?.predictionVariables || []}
        />
      </Col>
    </Row>
  );
}
